import { PopupUtility } from './popup-utility';

export const popupUtility = new PopupUtility({ global: window });
export default popupUtility;
